import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { postAPI } from 'store/apiReducer';
import { connect } from 'react-redux';
import { Button, ButtonGroup, Col, LoaderMi, Row, SelectControl } from '@si-armes/dsfr-react';
import { FormProvider, useForm } from 'react-hook-form';
import usagerClientReducer from '../../../store/usagerReducer';
import {
    API_CONTACTER_PREFECTURE_PRIVEE,
    API_CONTACTER_PREFECTURE_PRIVEE_MODIFICATION_INFORMATIONS_PERSONNELLES,
    CONTEXT_CONTACTER_PREFECTURE,
} from '../../../constants/apiUrls.constants';
import {
    formatDataContactGenerique,
    formatDataContactModificationInforamtionsPersonnelles,
} from './components/FormatDataContact';
import RoutesRatelier from '../ratelier/routes';
import FormulaireContactGenerique from '../../../components/form/formulaireContactGenerique/FormulaireContactGenerique';
import FormulaireContactPourModificationInformationsPersonnelles from './components/FormulaireContactPourModificationInformationsPersonnelles';
import { getPath } from '../../../utils/router';
import { formaterOptions } from '../../../utils/utils';
import { DATA_THEME_CONNECTE } from '../../../constants/contacter.constants';
import { ROLE_TIREUR_SPORTIF } from '../../../utils/droitsEtRoles.constant';

const ContacterPrefecture = ({ isLoading, postApi, roles }) => {
    const hookForm = useForm({
        mode: 'onChange',
    });
    const { register, handleSubmit, watch } = hookForm;

    const history = useHistory();

    const redirectionToRatelier = () => {
        history.push(getPath(RoutesRatelier));
    };

    const isFormulaireContactGenerique = () => {
        return watch('theme') !== "Demande de modification d'informations personnelles";
    };

    const isFormulaireContactDemandeModificationInformations = () => {
        return watch('theme') === "Demande de modification d'informations personnelles";
    };

    const hasFormValid = () => {
        if (isFormulaireContactGenerique()) return watch('theme') && watch('message');
        return (
            watch('theme') &&
            watch('sexe') &&
            watch('nom') &&
            watch('prenomUn') &&
            watch('dateNaissance') &&
            watch('paysNaissance') &&
            (watch('paysNaissance') !== '75' ||
                (watch('paysNaissance') === '75' && watch('departementNaissance'))) &&
            watch('lieuNaissance') &&
            watch('nationalite') &&
            watch('typePieceIdentite') &&
            watch('numeroPieceIdentite') &&
            watch('message')
        );
    };

    const onSubmit = async (dataForm) => {
        if (dataForm && isFormulaireContactGenerique() && hasFormValid()) {
            const dataFormat = await formatDataContactGenerique(dataForm, true);

            postApi(
                usagerClientReducer,
                API_CONTACTER_PREFECTURE_PRIVEE,
                dataFormat,
                CONTEXT_CONTACTER_PREFECTURE,
            );
            setTimeout(() => {
                redirectionToRatelier();
            }, 3000);
        }
        if (dataForm && isFormulaireContactDemandeModificationInformations() && hasFormValid()) {
            const dataFormat = await formatDataContactModificationInforamtionsPersonnelles(
                dataForm,
                true,
            );

            postApi(
                usagerClientReducer,
                API_CONTACTER_PREFECTURE_PRIVEE_MODIFICATION_INFORMATIONS_PERSONNELLES,
                dataFormat,
                CONTEXT_CONTACTER_PREFECTURE,
            );
            setTimeout(() => {
                redirectionToRatelier();
            }, 3000);
        }
    };

    const getLegende = () => {
        if (isFormulaireContactDemandeModificationInformations()) {
            return "Pour demander la modification d'une information, veuillez la corriger dans le champ correspondant ci-dessous. Les champs grisés correspondent aux informations que vous pouvez corriger directement depuis votre gestion de compte en cliquant sur votre nom situé en haut à droite de votre écran.";
        }

        return '';
    };

    return (
        <>
            <div className="margin-bottom-lg">
                {isLoading && <LoaderMi taille="md" />}
                <h1 className="margin-top-sm">Nous contacter</h1>
                <FormProvider {...hookForm}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Row gutters className="margin-bottom-md">
                            <Col lg={6}>
                                <SelectControl
                                    hintText={getLegende()}
                                    label="Thème *"
                                    id="theme"
                                    name="theme"
                                    options={formaterOptions(
                                        DATA_THEME_CONNECTE.filter((theme) => {
                                            if (roles && !roles.includes(ROLE_TIREUR_SPORTIF)) {
                                                return !theme.restriction;
                                            }
                                            return theme;
                                        }),
                                    )}
                                    placeholder="-- Choisir une option --"
                                    {...register('theme', {
                                        required: 'Ce champ est obligatoire',
                                    })}
                                    required
                                />
                            </Col>
                        </Row>
                        {isFormulaireContactGenerique() && <FormulaireContactGenerique />}
                        {isFormulaireContactDemandeModificationInformations() && (
                            <FormulaireContactPourModificationInformationsPersonnelles />
                        )}
                        <ButtonGroup align="right" inline>
                            <Button
                                name="Annuler"
                                variant="secondary"
                                onClick={redirectionToRatelier}
                                type="button"
                            >
                                Annuler
                            </Button>
                            <Button
                                name="envoyer"
                                variant="primary"
                                type="submit"
                                disabled={!hasFormValid() || isLoading}
                            >
                                Envoyer
                            </Button>
                        </ButtonGroup>
                    </form>
                </FormProvider>
            </div>
        </>
    );
};

ContacterPrefecture.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    postApi: PropTypes.func.isRequired,
    roles: PropTypes.array,
};

export default connect(
    (state) => {
        const { isLoading } = state.contact.nousContacter;
        return {
            isLoading,
        };
    },
    {
        postApi: postAPI,
    },
)(ContacterPrefecture);
